<template>
  <v-card outlined>
    <v-card-subtitle class="d-flex align-center">
      <span>{{ getPriorityCardTitle(priority) }}</span>
      <v-spacer />
      <!-- Fallback Partners Tooltip -->
      <template v-if="Number(priority) === 999">
        <v-tooltip top max-width="400">
          <template #activator="{ on }">
            <v-icon v-on="on">help</v-icon>
          </template>
          <div>
            These partners do not have a specified priority or traffic distribution. They will only be sent a
            registration if those with priority fail.
          </div>
        </v-tooltip>
      </template>
      <div v-if="optionalLabel" class="ml-4 font-italic">{{ optionalLabel }}</div>
    </v-card-subtitle>
    <v-list class="py-0" :disabled="disabled">
      <v-list-item
        v-for="(partner, index) in partners"
        :key="partner.id"
        :to="{ name: 'traffic.links', query: { partner: partner.slug } }"
        :class="{ 'grey lighten-4': index % 2 === 0 }"
      >
        <item-logo :src="partner.logoThumbnail" :name="partner.name" class="mr-2" :size="36" />
        <v-list-item-content>
          <v-list-item-title>{{ partner.name }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="Number(priority) !== 999">
          <span class="d-flex align-baseline">
            <span class="text-caption mr-2">
              Traffic Distribution:
            </span>
            <span class="font-weight-bold text-h6"> {{ partner.rule.percentage }}% </span>
          </span>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import ItemLogo from '@/components/item-logo'

export default {
  name: 'TrafficPartnerList',
  components: { ItemLogo },
  props: {
    partners: {
      type: Array,
      required: true,
    },
    priority: {
      type: [Number, String],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    optionalLabel: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    getPriorityCardTitle(priority) {
      if (Number(priority) === 999) return 'Remaining Partners'
      return `Priority ${priority}`
    },
  },
}
</script>
